// Vendor libraries
import { createReducer, on } from '@ngrx/store';
import { setBulkSelectedFolderablesOperation } from './bulk-selected-folderables-operation.action';
export const BULK_SELECTED_FOLDERABLES_OPERATION_SLICE_KEY = 'bulkSelectedFolderablesOperation';
/**
 * Reducer to save the bulk selected folderable item and operation to perform on them.
 * This reducer supports selecting all folderable types.
 */
export const bulkSelectedFolderablesOperation = createReducer(null, on(setBulkSelectedFolderablesOperation, (_, action) => {
    return action.selectedOperation;
}));
